// extracted by mini-css-extract-plugin
module.exports = {"sidedrawer":"SideDrawer-module--sidedrawer--fFz6Q","close":"SideDrawer-module--close--2MI5X","open":"SideDrawer-module--open--39Xpp"};